module.exports = __webpack_public_path__ + "img/image-8.e6495358.jpg";